import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Tjanster from "@/pages/Tjanster";
import Kontorsstadning from "@/pages/Kontorsstadning";
import Byggstadning from "@/pages/Byggstadning";
import Butiksstadning from "@/pages/Butiksstadning";
import Arbetsbodar from "@/pages/Arbetsbodar";
import Golvvard from "@/pages/Golvvard";
import OmOss from "@/pages/OmOss";
import MiljoHallbarhet from "@/pages/MiljoHallbarhet";
import Kontakt from "@/pages/Kontakt";
import Integritetspolicy from "@/pages/Integritetspolicy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tjanster" element={<Tjanster />} />
            <Route path="/tjanster/kontorsstadning" element={<Kontorsstadning />} />
            <Route path="/tjanster/byggstadning" element={<Byggstadning />} />
            <Route path="/tjanster/butiksstadning" element={<Butiksstadning />} />
            <Route path="/tjanster/stadning-av-arbetsbodar" element={<Arbetsbodar />} />
            <Route path="/golvvard" element={<Golvvard />} />
            <Route path="/om-oss" element={<OmOss />} />
            <Route path="/miljo-och-hallbarhet" element={<MiljoHallbarhet />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/integritetspolicy" element={<Integritetspolicy />} />

            {/* Bakåtkompatibla redirects (gamla URL:er) */}
            <Route path="/foretagskunder" element={<Navigate to="/tjanster" replace />} />
            <Route path="/foretagskunder/kontorsstadning" element={<Navigate to="/tjanster/kontorsstadning" replace />} />
            <Route path="/foretagskunder/byggstadning" element={<Navigate to="/tjanster/byggstadning" replace />} />
            <Route path="/foretagskunder/butiksstadning" element={<Navigate to="/tjanster/butiksstadning" replace />} />
            <Route path="/foretagskunder/stadning-av-arbetsbodar" element={<Navigate to="/tjanster/stadning-av-arbetsbodar" replace />} />
            <Route path="/privatpersoner/*" element={<Navigate to="/" replace />} />
            <Route path="/privatpersoner" element={<Navigate to="/" replace />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
